import type { FC, SVGProps } from "react";
import React from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const FullscreenIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="fullscreen icon">
      {/* <title>fullscreen icon</title> */}
      <rect
        opacity="0.8"
        y="0.20105"
        width="49.7015"
        height="49.8324"
        rx="10"
        fill="#FAFAFA"
      />
      <g clipPath="url(#clip0_4662_26799)">
        <path
          d="M32.4732 22.6646V18.8936L26.2658 25.1173L32.4732 31.341V27.57C32.4732 26.9918 32.945 26.5188 33.5216 26.5188C34.0982 26.5188 34.57 26.9918 34.57 27.57V33.8769C34.57 34.0137 34.5421 34.1501 34.489 34.2786C34.3827 34.5354 34.1787 34.7402 33.9228 34.8466C33.7924 34.9017 33.657 34.928 33.5216 34.928H27.2312C26.6546 34.928 26.1828 34.4594 26.1828 33.8769C26.1828 33.2944 26.6524 32.8257 27.2312 32.8257H30.9906L24.785 26.602L18.5794 32.8257H22.3387C22.9197 32.8257 23.3871 33.2987 23.3871 33.8769C23.3871 34.455 22.9197 34.928 22.3387 34.928H16.0484C15.9119 34.928 15.7759 34.9 15.6477 34.8469C15.3916 34.7403 15.1873 34.5357 15.0812 34.2789C15.028 34.1528 15 34.0126 15 33.8769V27.57C15 26.9918 15.4696 26.5188 16.0484 26.5188C16.6272 26.5188 17.0968 26.9918 17.0968 27.57V31.3392L23.3041 25.1173L17.0968 18.8936V22.6646C17.0968 23.2471 16.6272 23.7157 16.0484 23.7157C15.4696 23.7157 15 23.2471 15 22.6646V16.3577C15 16.2208 15.0279 16.0845 15.081 15.956C15.1872 15.6992 15.3913 15.4943 15.6471 15.3879C15.7754 15.3345 15.9117 15.3065 16.0484 15.3065H22.3387C22.9197 15.3065 23.3871 15.7773 23.3871 16.3577C23.3871 16.938 22.9197 17.4088 22.3387 17.4088H18.5794L24.785 23.6325L30.9923 17.4088H27.2312C26.6546 17.4088 26.1828 16.938 26.1828 16.3577C26.1828 15.7773 26.6546 15.3065 27.2312 15.3065H33.5216C33.6581 15.3065 33.7941 15.3346 33.9222 15.3876C34.1783 15.4942 34.3827 15.6988 34.4888 15.9557C34.5438 16.0839 34.57 16.2206 34.57 16.3577V22.6646C34.57 23.2471 34.1026 23.7157 33.5216 23.7157C32.9406 23.7157 32.4732 23.2471 32.4732 22.6646Z"
          fill="#495057"
        />
      </g>
      <defs>
        <clipPath id="clip0_4662_26799">
          <rect
            width="19.57"
            height="22.4246"
            fill="white"
            transform="translate(15 13.905)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FullscreenIcon;
